import { render, staticRenderFns } from "./PositionPeripheralRelate.vue?vue&type=template&id=1a424ad1"
import script from "./PositionPeripheralRelate.vue?vue&type=script&lang=js"
export * from "./PositionPeripheralRelate.vue?vue&type=script&lang=js"
import style0 from "./PositionPeripheralRelate.vue?vue&type=style&index=0&id=1a424ad1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports